<template>
  <EditorContentImage
    v-if="['img'].includes(props.type)"
    :editable="editable"
    :image-src="attrs.src"
    :position="attrs['data-position']"
    :rotate="attrs['data-rotate']"
    :description="attrs['data-description']"
    :source="attrs['data-source']"
    :width="attrs['data-width']"
    v-bind="mark && { marks: [mark, ...marks] }"
  />
  <Component
    :is="tag"
    v-else
    :style="mark?.attrs ?? marks[0]?.attrs ?? attrs"
    :editable="editable"
    v-bind="attributes"
    @on-set-info="emit('on-set-info', $event)"
  >
    <EditorParagraphBlockContent
      v-if="marks.length"
      :mark="marks[0]"
      :marks="marks.slice(1)"
      :text="text"
    />
    <template v-else-if="text">
      {{ text }}
    </template>
  </Component>
</template>

<script setup>
import ContentImage from '@/components/Editor/ContentImage/ContentImage.vue';
import InfoIcon from '@/components/Editor/InfoIcon/InfoIcon.vue';

const props = defineProps({
  editable: {
    type: Boolean,
    default: false,
  },
  marks: {
    type: Array,
    default: () => [],
  },
  mark: {
    type: Object,
    default: null,
  },
  text: {
    type: [String, Number],
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  attrs: {
    type: Object,
    default: () => ({}),
  },
  textInfo: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['on-set-info']);

const getTag = (type) => {
  if (!type) return 'span';
  const types = {
    italic: 'em',
    bold: 'strong',
    textStyle: 'span',
    text: 'span',
    link: 'a',
    underline: 'u',
    listItem: 'li',
    paragraph: 'p',
    img: ContentImage,
    'info-icon': InfoIcon,
  };

  return types[type] ?? type;
};

const markType = computed(() => {
  return props.mark?.type ?? props.marks[0]?.type ?? props.type;
});

const tag = computed(() => {
  return getTag(markType.value);
});

const attributes = computed(() => {
  const attrs = props.mark?.attrs ?? props.marks[0]?.attrs ?? {};
  if (tag.value !== 'a') {
    attrs.text = props.textInfo;
  }
  return attrs;
});
</script>
